import SPI from './SPI';

export default SPI;
